import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { GET_PAIRING_STATUS } from '../get-pairing-status';
import { deletePairingAPI } from './api';

export function useDeletePairing({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (userEmail) => deletePairingAPI(userEmail),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([GET_PAIRING_STATUS, tenantId, variables]);
        if (onSuccess) onSuccess(data);
      },
      onError: (err) => {
        if (onError) onError(err);
      },
    },
  );

  return {
    deletePairing: mutate,
    mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}

